<template>
  <div class="row">
    <!--FLIGHT PREPARATION-->
    <div class="col-xl-8 d-flex">
      <next-activity v-if="isLoginValid && tokenReady"/>
      <template v-else>
        <div class="card-body py-0">
          <div class="empty-status">
            <div class="icon"><i class="fa fa-plane text-muted"></i></div>
            <div class="title">No data found please sign in again</div>
          </div>
        </div>
      </template>
    </div>
    <!--BULLETIN-->
    <div class="col-md-6 col-xl-4 d-flex">
      <div class="card flex-grow-1">
        <div class="card-header">
          <div class="card-title">BULLETIN</div>
          <div class="card-tool">
            <a :href="'/#/d1folderlist/bulletin'">MORE</a>
          </div>
        </div>
        <div class="card-body py-0 h-sm-0">
          <ul v-if="files.length > 0 && tokenReady" class="list-news">
            <li v-for="(file, index) in files.slice(0, 10)" v-bind:key="index">
              <a v-bind:href="file.webUrl" target="_blank">
                <div class="icon">
                  <span class="fa-stack">
                    <i v-bind:class="getFileIcon(file.name)">{{
                      file.name.split('.')[file.name.split('.').length - 1].toUpperCase()
                    }}</i>
                    <i class="fa fa-file-o fa-stack-1x"></i>
                  </span>
                </div>
                <div class="con">
                  <div class="title">{{ file.name }}</div>
                  <div class="text">
                    {{ $moment(file.createdDateTime).format('YYYY-MM-DD HH:mm:ss') }}
                  </div>
                </div>
                <div v-if="file.listItem && file.listItem.fields.Priority > 0" class="icon ml-auto align-self-center">
                  <i class="fa fa-thumb-tack text-lg"></i>
                </div>
              </a>
            </li>
          </ul>
          <div v-else class="empty-status">
            <div class="icon"><i class="icons icon-list"></i></div>
            <div class="title">No result</div>
          </div>
        </div>
      </div>
    </div>
    <!--CASE STUDY-->
    <div class="col-md-6 col-xl-4 d-flex">
      <div class="card flex-grow-1">
        <div class="card-header">
          <div class="card-title">CASE STUDY</div>
          <div class="card-tool">
            <a :href="'/#/folderdetail/CASE STUDY'">MORE</a>
          </div>
        </div>
        <div class="card-body">
          <ul v-if="caseStudy.length > 0 && tokenReady" class="list-news">
            <li v-for="(file, index) in caseStudy.slice(0, 10)" v-bind:key="index">
              <a v-bind:href="file.webUrl" target="_blank">
                <div class="icon">
                  <span class="fa-stack">
                    <i v-bind:class="getFileIcon(file.name)">{{
                      file.name.split('.')[file.name.split('.').length - 1].toUpperCase()
                    }}</i>
                    <i class="fa fa-file-o fa-stack-1x"></i>
                  </span>
                </div>
                <div class="con">
                  <div class="title">{{ file.name }}</div>
                  <div class="text">
                    {{ $moment(file.createdDateTime).format('YYYY-MM-DD HH:mm:ss') }}
                  </div>
                </div>
                <div v-if="file.listItem.fields.Priority > 0" class="icon ml-auto align-self-center">
                  <i class="fa fa-thumb-tack text-lg"></i>
                </div>
              </a>
              <template v-if="index + 1 < caseStudy.length">
                <hr
                  class="my-0"
                  v-if="
                    file.listItem.fields.Priority > caseStudy[index + 1].listItem.fields.Priority &&
                    caseStudy[index + 1].listItem.fields.Priority == 1
                  "
                />
              </template>
            </li>
          </ul>
          <div v-else class="empty-status">
            <div class="icon"><i class="icons icon-list"></i></div>
            <div class="title">No result</div>
          </div>
        </div>
      </div>
    </div>

    <!--CREW CONTACT-->
    <div class="col-md-6 col-xl-4 d-flex">
      <div class="card flex-grow-1">
        <div class="card-header">
          <div class="card-title">CREW CONTACT</div>
          <div class="card-tool">
            <a href="#"></a>
          </div>
        </div>
        <div class="card-body py-0 h-sm-0">
          <ul v-if="crewConnect.length > 0 && tokenReady" class="list-news">
            <li v-for="(crew, index) in crewConnect.slice(0, 10)" v-bind:key="index" class="d-flex align-items-center">
              <div class="con mr-auto p-4">
                <div class="text-dark mb-10">{{ crew.fields.Title }}</div>
                <div class="text">{{ crew.fields.Tel }}</div>
                <div class="text">{{ crew.fields.Email }}</div>
              </div>
              <!-- <a v-bind:href="'tel:' + crew.fields.Tel" class="btn btn-default rounded-circle mr-4 p-4"
                ><i class="icons icon-phone fa-lg"></i
              ></a> -->
              <div class="d-flex">
                <a v-bind:href="'mailto:' + crew.fields.Email" class="btn btn-default rounded-circle mr-4 p-4"
                  ><i class="icons icon-envelope fa-lg"></i
                ></a>
                <div v-if="crew.fields.Priority > 0" class="icon ml-auto align-self-center">
                  <i class="fa fa-thumb-tack text-lg"></i>
                </div>
              </div>
            </li>
          </ul>
          <div v-else class="empty-status">
            <div class="icon"><i class="icons icon-list"></i></div>
            <div class="title">No result</div>
          </div>
        </div>
      </div>
    </div>
    <!--RESOURCES-->
    <div class="col-md-6 col-xl-4 d-flex">
      <div class="card flex-grow-1">
        <div class="card-header">
          <div class="card-title">RESOURCES</div>
          <div class="card-tool"></div>
        </div>
        <div class="card-body h-sm-0">
          <ul v-if="tokenReady" class="list-logo">
            <li v-for="item in resourceList" :key="item.title">
              <a :href="item.href" target="_blank">
                <div class="icon" :style="{ 'background-image': `url(/img/${item.icon})` }"></div>
                <div class="title">{{ item.title }}</div>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NextActivity from '@/components/NextActivity'

export default {
  name: 'Home',
  components: {
    NextActivity
  },
  data: () => ({
    newsclip: [],
    news: [],
    files: [],
    crewConnect: [],
    caseStudy: [],
    fileLength: 0,
    isLoginValid: true,
    tokenReady: false,
    searchMail: localStorage.getItem('mail'),
    resourceList: [
      {
        icon: 'icon_Lido.png',
        title: 'Lido Briefing',
        href: 'https://sjx.lido.aero/lido/las/login.jsp'
      },
      {
        icon: 'icon_wni.png',
        title: 'WNI FPL Editor',
        href: 'https://flight-plan-editor.weathernews.com/flight_plan_editor/#login'
      },
      {
        icon: 'icon_NOTAM.png',
        title: 'NOTAM',
        href: 'https://notams.aim.faa.gov/notamSearch/disclaimer.html'
      },
      {
        icon: 'icon_aoaws.jpg',
        title: 'AOAWS',
        href: 'https://aoaws.anws.gov.tw/'
      },
      {
        icon: 'icon_tono2.svg',
        title: 'フライトお天気 (tono2.net)',
        href: 'https://tono2.net/'
      },
      {
        icon: 'icon_awc.jpg',
        title: 'Aviation Weather Center',
        href: 'https://www.aviationweather.gov'
      },
      {
        icon: 'icon_ELB.png',
        title: 'ELB Ground Station',
        href: 'https://elb.starlux-airlines.com/elb/#/tail/B-58304'
      },
      {
        icon: 'icon_AES.png',
        title: 'Aero E-Service',
        href: 'https://aiss.anws.gov.tw/aes/login.jsp'
      },
      {
        icon: 'icon_safety_first.jpg',
        title: 'Airbus Safety First',
        href: 'https://safetyfirst.airbus.com/'
      }
    ]
  }),
  methods: {
    getFileLength(fileobj) {
      this.fileLength = fileobj.name.split('.').length
    },
    getFileIcon(filename) {
      var temp = filename.split('.')[filename.split('.').length - 1].toLowerCase()
      switch (temp) {
        case 'pptx':
        case 'ppt':
          return 'fa fa-stack-1x text-xs bg-dark'
        case 'pdf':
          return 'fa fa-stack-1x text-xs bg-danger'
        case 'jpg':
        case 'jpeg':
        case 'png':
        case 'gif':
          return 'fa fa-stack-1x text-xs bg-success'
        case 'mp4':
        case 'wmv':
        case 'mov':
          return 'fa fa-stack-1x text-xs'
        default:
          return 'fa fa-stack-1x text-xs d-none'
      }
    },
    sortByKey(array, key, order) {
      return array.sort((a, b) => {
        var x = a[key] || 0
        var y = b[key] || 0
        if (order === 'DESC') {
          return x < y ? 1 : x > y ? -1 : 0
        } else if (order === 'ASC') {
          return x < y ? -1 : x > y ? 1 : 0
        }
      })
    },
    sortByPiority(array, order) {
      // console.log('array',array)
      return array.sort((a, b) => {
        var x = a.listItem ? a.listItem.fields.Priority || 0 : a.fields.Priority || 0
        var y = b.listItem ? b.listItem.fields.Priority || 0 : b.fields.Priority || 0

        if (order === 'DESC') {
          return x < y ? 1 : x > y ? -1 : 0
        } else if (order === 'ASC') {
          return x < y ? -1 : x > y ? 1 : 0
        }
      })
    }
  },
  computed: {},
  async created() {
    this.$store.dispatch('setImpersonateMail', '') // Clear impersonate email in store

    try {
      const resp = await this.getEIPNewsList(localStorage.getItem('access_token'), 3);
      this.newsclip = resp.data.value;
      this.sortByKey(this.newsclip, 'createdDateTime', 'DESC');
    } catch (err) { 
      console.log('err', err);
    } finally {
      // 不管成功失敗，都通知外層可以放行了
      this.tokenReady = true;
    }

    this.getPilotBulletinFile(localStorage.getItem('access_token'), 'General')
      .then(resp => {
        this.files = resp.data.value
        this.sortByPiority(this.files, 'DESC')
      })
      .catch(err => {
        console.log('err', err)
      })
    this.getPilotConnectList(localStorage.getItem('access_token'))
      .then(resp => {
        this.crewConnect = resp.data.value
        this.sortByPiority(this.crewConnect, 'DESC')
      })
      .catch(err => {
        console.log('err', err)
      })
    this.getPilotPortalDocumentFile(localStorage.getItem('access_token'), 'CASE STUDY')
      .then(resp => {
        this.caseStudy = resp.data.value
        this.sortByPiority(this.caseStudy, 'DESC')
      })
      .catch(err => {
        console.log('err', err);
        if (err.response && (err.response.status === 401 || err.response.status === 403)) {
          this.isLoginValid = false
          this.$store.dispatch('logout').then(() => {
            this.$router.push('/login');
          });
        }
      })
  }
}
</script>
